var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13431 0.420573L26.2948 27.5995C26.783 28.1487 26.7829 29.039 26.2947 29.5882C25.8065 30.1373 25.015 30.1373 24.5269 29.5881L18.2178 22.4898L6.15385 22.4901C2.75517 22.4901 0 19.3989 0 15.5856C0 11.8502 2.64386 8.80762 5.94662 8.68499L0.366399 2.40919C-0.121777 1.86003 -0.121758 0.969674 0.366437 0.420532C0.854632 -0.12861 1.64613 -0.128592 2.13431 0.420573ZM15 0C20.2812 0 23.2771 3.93227 23.7129 8.68115L23.8462 8.68115C27.2448 8.68115 30 11.7724 30 15.5856C30 18.8975 27.9217 21.6647 25.1486 22.3351L8.21832 3.28348C9.69164 1.28491 11.969 0 15 0Z",
    fill: "#f44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOff);
export default __webpack_public_path__ + "res/media/off.8778abb568035ec0eee2ae71ac199619.svg";
export { ForwardRef as ReactComponent };